export const getSubmittalPermissionSet = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const perms = Array.isArray(user.permissions) ? user.permissions : [];
    return new Set(perms.map((p) => String(p)));
  } catch (_) {
    return new Set();
  }
};

export const isSubmittalPrivileged = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const roleCodes = Array.isArray(user.role_codes) ? user.role_codes.map((x) => String(x).toUpperCase()) : [];
    const legacy = String(user.role || '').toUpperCase();
    return roleCodes.includes('SUPER_ADMIN') || roleCodes.includes('ADMIN') || legacy === 'SUPER_ADMIN' || legacy === 'ADMIN';
  } catch (_) {
    return false;
  }
};

export const hasSubmittalPermission = (actionKey) => {
  if (isSubmittalPrivileged()) return true;
  const set = getSubmittalPermissionSet();
  if (!set.size) return true;
  return set.has(`submittal:${actionKey}`) || set.has('submittal:admin') || set.has('*:*');
};

export const CONSULTANT_REVIEW_BLOCKED_MSG = 'Consultant review is required for this category before client submission.';

export const WORKFLOW_ACTIONS = [
  { key: 'submit-internal-review', label: 'Submit for Internal Review', permission: 'submit', statuses: ['DRAFT'] },
  { key: 'submit-to-consultant', label: 'Submit to Consultant', permission: 'submit', statuses: ['INTERNAL_REVIEW', 'RESUBMITTED'] },
  { key: 'recommend-to-client', label: 'Recommend to Client', permission: 'review', statuses: ['PENDING_CONSULTANT_REVIEW', 'SUBMITTED_TO_CONSULTANT'] },
  { key: 'submit-to-client', label: 'Submit to Client', permission: 'submit', statuses: ['INTERNAL_REVIEW', 'RECOMMENDED_TO_CLIENT', 'RESUBMITTED'] },
  { key: 'comment', label: 'Add Comment', permission: 'review', statuses: ['PENDING_CONSULTANT_REVIEW', 'SUBMITTED_TO_CONSULTANT', 'PENDING_CLIENT_APPROVAL', 'SUBMITTED_TO_CLIENT'] },
  { key: 'approve', label: 'Approve', permission: 'approve', statuses: ['PENDING_CLIENT_APPROVAL', 'SUBMITTED_TO_CLIENT'] },
  { key: 'approve-with-comments', label: 'Approve with Comments', permission: 'approve', statuses: ['PENDING_CLIENT_APPROVAL', 'SUBMITTED_TO_CLIENT'] },
  { key: 'return-for-revision', label: 'Return for Revision', permission: 'return', statuses: ['PENDING_CONSULTANT_REVIEW', 'SUBMITTED_TO_CONSULTANT', 'PENDING_CLIENT_APPROVAL', 'SUBMITTED_TO_CLIENT'] },
  { key: 'reject', label: 'Reject', permission: 'reject', statuses: ['PENDING_CONSULTANT_REVIEW', 'SUBMITTED_TO_CONSULTANT', 'PENDING_CLIENT_APPROVAL', 'SUBMITTED_TO_CLIENT'] },
  { key: 'resubmit', label: 'Resubmit', permission: 'resubmit', statuses: ['RETURNED_BY_CONSULTANT', 'RETURNED_BY_CLIENT'] },
  { key: 'close', label: 'Close', permission: 'close', statuses: ['APPROVED', 'APPROVED_WITH_COMMENTS', 'REJECTED'] },
  { key: 'cancel', label: 'Cancel', permission: 'edit_draft', statuses: ['DRAFT'] },
  { key: 'reassign', label: 'Reassign', permission: 'admin', statuses: ['INTERNAL_REVIEW', 'PENDING_CONSULTANT_REVIEW', 'SUBMITTED_TO_CONSULTANT', 'PENDING_CLIENT_APPROVAL', 'SUBMITTED_TO_CLIENT', 'RETURNED_BY_CONSULTANT', 'RETURNED_BY_CLIENT'] },
  { key: 'extend-due-date', label: 'Extend Due Date', permission: 'admin', statuses: null },
];

const resolveSubmittalContext = (submittalOrStatus) => {
  if (submittalOrStatus && typeof submittalOrStatus === 'object') {
    return {
      status: String(submittalOrStatus.status || '').toUpperCase(),
      category: submittalOrStatus.category || null,
    };
  }
  return {
    status: String(submittalOrStatus || '').toUpperCase(),
    category: null,
  };
};

const categoryRequiresConsultantReview = (category) => {
  if (!category) return false;
  const flag = category.requires_consultant_review ?? category.requiresConsultantReview;
  return flag === true;
};

export const isSubmitToClientBlocked = (submittalOrStatus) => {
  const { status, category } = resolveSubmittalContext(submittalOrStatus);
  return status === 'INTERNAL_REVIEW' && categoryRequiresConsultantReview(category);
};

export const getAvailableWorkflowActions = (submittalOrStatus) => {
  const { status } = resolveSubmittalContext(submittalOrStatus);
  return WORKFLOW_ACTIONS.filter((action) => {
    if (!hasSubmittalPermission(action.permission)) return false;
    if (action.key === 'submit-to-client' && isSubmitToClientBlocked(submittalOrStatus)) return false;
    if (action.statuses == null) {
      return !['APPROVED', 'APPROVED_WITH_COMMENTS', 'REJECTED', 'CLOSED', 'CANCELLED'].includes(status);
    }
    return action.statuses.includes(status);
  });
};
